




















































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwDropdownUnit } from '@sonicwall/unified-ui-framework/src/shared/dropdown-dir';

const cssPrefix = 'dropdown-light-unit';

@Component({
  components:{
    SwDropdownUnit,
  },
})
export default class DropdownLightUnit extends SwExtendedVue{
  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  highlight: boolean;

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  cssPrefix = cssPrefix;
}
